'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _useMounted = require('react-utils/hooks/useMounted');

var _useMounted2 = _interopRequireDefault(_useMounted);

var _usePrevious = require('react-utils/hooks/usePrevious');

var _usePrevious2 = _interopRequireDefault(_usePrevious);

var _ModalTransitionContext = require('../context/ModalTransitionContext');

var _EventHandlers = require('../core/EventHandlers');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _memoWithDisplayName = require('../utils/memoWithDisplayName');

var _memoWithDisplayName2 = _interopRequireDefault(_memoWithDisplayName);

var _domElement = require('../utils/propTypes/domElement');

var _domElement2 = _interopRequireDefault(_domElement);

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

var _PlacementConstants = require('./PlacementConstants');

var _UIAbstractPopup = require('./UIAbstractPopup');

var _UIAbstractPopup2 = _interopRequireDefault(_UIAbstractPopup);

var _UIPopoverArrow = require('./UIPopoverArrow');

var _UIPopoverArrow2 = _interopRequireDefault(_UIPopoverArrow);

var _UIPopoverContent = require('./UIPopoverContent');

var _UIPopoverContent2 = _interopRequireDefault(_UIPopoverContent);

var _Placement = require('./utils/Placement');

var _propTypes3 = require('./utils/propTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getArrowSize = function getArrowSize(arrowSize, use) {
  if (arrowSize != null) return arrowSize;
  if (use === 'tooltip' || use === 'tooltip-danger') return 'small';
  return 'medium';
};

var getAnimateOnToggle = function getAnimateOnToggle(animateOnToggle, computedArrowSize) {
  return animateOnToggle != null ? animateOnToggle : computedArrowSize !== 'none';
};

var UIPopover = (0, _memoWithDisplayName2.default)('UIPopover', function (props) {
  var _bodyElement = props._bodyElement,
      _distanceAdjustment = props._distanceAdjustment,
      _insetAdjustment = props._insetAdjustment,
      addTargetClasses = props.addTargetClasses,
      animateOnMount = props.animateOnMount,
      animateOnToggle = props.animateOnToggle,
      arrowSize = props.arrowSize,
      autoPlacement = props.autoPlacement,
      children = props.children,
      className = props.className,
      closeOnOutsideClick = props.closeOnOutsideClick,
      closeOnTargetLeave = props.closeOnTargetLeave,
      onChangePlacement = props.onChangePlacement,
      onCloseComplete = props.onCloseComplete,
      onFocusLeave = props.onFocusLeave,
      onOpenChange = props.onOpenChange,
      open = props.open,
      pinToConstraint = props.pinToConstraint,
      pinToOutOfBoundsTarget = props.pinToOutOfBoundsTarget,
      placement = props.placement,
      popoverRef = props.popoverRef,
      shouldCloseOnClick = props.shouldCloseOnClick,
      target = props.target,
      targetAttachment = props.targetAttachment,
      use = props.use,
      zIndex = props.zIndex,
      rest = _objectWithoutProperties(props, ['_bodyElement', '_distanceAdjustment', '_insetAdjustment', 'addTargetClasses', 'animateOnMount', 'animateOnToggle', 'arrowSize', 'autoPlacement', 'children', 'className', 'closeOnOutsideClick', 'closeOnTargetLeave', 'onChangePlacement', 'onCloseComplete', 'onFocusLeave', 'onOpenChange', 'open', 'pinToConstraint', 'pinToOutOfBoundsTarget', 'placement', 'popoverRef', 'shouldCloseOnClick', 'target', 'targetAttachment', 'use', 'zIndex']);

  var _useContext = (0, _react.useContext)(_ModalTransitionContext.ModalTransitionContext),
      inModalTransition = _useContext.transitioning;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      closeComplete = _useState2[0],
      setCloseComplete = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      placementOverride = _useState4[0],
      setPlacementOverride = _useState4[1];

  /** `contentOpen` triggers open/close transitions */


  var contentOpen = open && !inModalTransition;

  /** `tetherOpen` determines whether the popover is in the DOM */
  var tetherOpen = contentOpen || !closeComplete;

  // If a close transition is starting, update the closeComplete state.
  var prevContentOpen = (0, _usePrevious2.default)(contentOpen);
  if (prevContentOpen && !contentOpen && closeComplete) {
    setCloseComplete(false);
  }

  // If the placement prop is reset, clear our internal override
  var prevPlacement = (0, _usePrevious2.default)(placement);
  if (prevPlacement !== placement && placementOverride) {
    setPlacementOverride(null);
  }

  var contentRef = (0, _react.useRef)();
  var defaultPopoverRef = (0, _react.useRef)();

  var computedPlacement = placementOverride || placement;
  var computedPopoverRef = popoverRef || defaultPopoverRef;

  var mountedRef = (0, _useMounted2.default)();
  var isMounted = mountedRef.current;

  (0, _react.useEffect)(function () {
    if (contentOpen && onOpenChange) {
      var tetherTarget = target || computedPopoverRef.current.getTargetElement();

      var handleWindowClick = function handleWindowClick(evt) {
        // If `shouldCloseOnClick` is provided and returns a non-null value, defer to it
        if (shouldCloseOnClick) {
          var shouldClose = shouldCloseOnClick(evt);
          if (shouldClose != null) {
            if (shouldClose) onOpenChange((0, _SyntheticEvent2.default)(false));
            return;
          }
        }

        // Otherwise, use our standard algorithm for detecting "outside clicks"
        var clickTarget = evt.target;

        var contentEl = (0, _reactDom.findDOMNode)(contentRef.current);

        // Ignore the click if it's within our Tether target
        if (tetherTarget.contains(clickTarget)) return;

        // Ignore the click if it's within our popover container
        if (contentEl && (0, _EventHandlers.isClickWithinContainer)(evt, contentEl)) return;

        // Otherwise, trigger close
        onOpenChange((0, _SyntheticEvent2.default)(false));
      };

      var bindClickHandlerFrame = void 0;
      if (closeOnOutsideClick) {
        bindClickHandlerFrame = requestAnimationFrame(function () {
          // Wait a tick to prevent the same click that triggered open from triggering close
          addEventListener('click', handleWindowClick);
        });
      }

      // When closeOnTargetLeave is enabled, we use an IntersectionObserver to close the popover if
      // its target leaves the screen due to scrolling (#3856).
      var intersectionObserver = void 0;
      if (closeOnTargetLeave) {
        var _window = window,
            IntersectionObserver = _window.IntersectionObserver;

        if (IntersectionObserver) {
          intersectionObserver = new IntersectionObserver(function (entries) {
            var intersectionRatio = entries[0].intersectionRatio;

            if (intersectionRatio <= 0) {
              onOpenChange((0, _SyntheticEvent2.default)(false));
            }
          });
          intersectionObserver.observe(tetherTarget);
        }
      }

      return function () {
        cancelAnimationFrame(bindClickHandlerFrame);
        removeEventListener('click', handleWindowClick);
        if (intersectionObserver) {
          intersectionObserver.disconnect();
        }
      };
    }
    return undefined;
  },
  /* eslint-disable react-hooks/exhaustive-deps */[closeOnOutsideClick, closeOnTargetLeave, contentOpen, shouldCloseOnClick, target] /* eslint-enable react-hooks/exhaustive-deps */
  );

  var handleTetherUpdate = function handleTetherUpdate(evt) {
    // Adjust our placement state to reflect Tether's response to a constraint
    var newPlacement = (0, _Placement.computeNewPlacement)(computedPlacement, evt.targetAttachment, autoPlacement);
    if (!newPlacement) return;

    if (placementOverride !== newPlacement) {
      setPlacementOverride(newPlacement);
      if (onChangePlacement) onChangePlacement({ newPlacement: newPlacement });
    }
  };

  var handleCloseComplete = function handleCloseComplete() {
    if (onCloseComplete) onCloseComplete();
    if (isMounted) setCloseComplete(true);
  };

  // Perf: Don't generate props for the tether if we're closed.
  var popupProps = null;
  if (tetherOpen) {
    var computedArrowSize = getArrowSize(arrowSize, use);
    var computedAnimateOnToggle = getAnimateOnToggle(animateOnToggle, computedArrowSize);
    var computedArrowParams = _UIPopoverArrow2.default.ARROW_SIZES[computedArrowSize];

    var renderedContent = _react2.default.createElement(_UIPopoverContent2.default, _extends({}, rest, {
      animateOnMount: Boolean(animateOnMount && !isMounted || computedAnimateOnToggle && isMounted),
      animateOnToggle: computedAnimateOnToggle,
      arrowSize: computedArrowSize,
      className: className,
      'data-component-name': 'UIPopover',
      onCloseComplete: handleCloseComplete,
      open: contentOpen,
      placement: computedPlacement,
      ref: contentRef,
      use: use,
      onOpenChange: onOpenChange
    }));

    popupProps = {
      addTargetClasses: addTargetClasses,
      autoPlacement: autoPlacement,
      bodyElement: _bodyElement,
      center: computedArrowSize !== 'none',
      content: renderedContent,
      distance: computedArrowParams.distance + _distanceAdjustment,
      inset: computedArrowParams.inset + _insetAdjustment,
      onFocusLeave: onFocusLeave,
      onTetherUpdate: handleTetherUpdate,
      open: tetherOpen,
      pinToConstraint: pinToConstraint,
      pinToOutOfBoundsTarget: pinToOutOfBoundsTarget,
      placement: computedPlacement,
      ref: computedPopoverRef,
      target: target,
      targetAttachment: targetAttachment,
      zIndex: zIndex
    };
  }

  return _react2.default.createElement(
    _UIAbstractPopup2.default,
    popupProps,
    children
  );
});

UIPopover.propTypes = _extends({}, _UIPopoverContent2.default.propTypes, {
  addTargetClasses: _propTypes2.default.bool,
  arrowSize: _propTypes2.default.oneOf(Object.keys(_UIPopoverArrow2.default.ARROW_SIZES)),
  autoPlacement: _propTypes3.autoPlacementPropType,
  children: _propTypes2.default.element,
  closeOnOutsideClick: _propTypes2.default.bool.isRequired,
  closeOnTargetLeave: _propTypes2.default.bool.isRequired,
  onFocusLeave: _propTypes2.default.func,
  onChangePlacement: _propTypes2.default.func,
  onOpenChange: _propTypes2.default.func,
  pinToConstraint: _propTypes3.pinToConstraintPropType,
  pinToOutOfBoundsTarget: _propTypes2.default.bool,
  popoverRef: _refObject2.default,
  placement: _propTypes2.default.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
  shouldCloseOnClick: _propTypes2.default.func,
  target: _domElement2.default,
  targetAttachment: _propTypes2.default.string.isRequired,
  zIndex: _propTypes2.default.number.isRequired,
  _distanceAdjustment: _propTypes2.default.number,
  _insetAdjustment: _propTypes2.default.number,
  _bodyElement: _domElement2.default
});

UIPopover.defaultProps = _extends({}, _UIPopoverContent2.default.defaultProps, {
  autoPlacement: true,
  closeOnOutsideClick: true,
  closeOnTargetLeave: false,
  _distanceAdjustment: 0,
  _insetAdjustment: 0,
  pinToConstraint: ['top', 'bottom'],
  pinToOutOfBoundsTarget: false,
  targetAttachment: 'auto',
  zIndex: _UIAbstractPopup2.default.defaultProps.zIndex
});

var UIControlledPopover = UIPopover;
exports.default = UIControlledPopover;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/tooltip/UIControlledPopover.js
// module id = 111
// module chunks = 177